import { Loading } from "notiflix";
import toast from "react-hot-toast";
import AppleSvg from "../assets/svg/Apple.svg";
import GoogleSvg from "../assets/svg/Gpay.svg";
import PaypalSvg from "../assets/svg/paypal.svg";
import StripeSvg from "../assets/svg/Stripe.svg";
import React, { useEffect, useState } from "react";
import { ApiURL } from "../setting/GlobleVariable";
import CreditSvg from "../assets/svg/Credit card.svg";
import { useDispatch, useSelector } from "react-redux";
import { CreateOrder, GetTaxData, CreateUserCreatedOrder } from "../redux/actions/Events";
import MarketplaceNewUIFooter from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIFooter";
import {
  checkoutCard,
  checkoutContainer,
  checkoutErrorAlert,
  checkoutEventTitle,
  checkoutPage,
  checkoutPageTitle,
  checkoutSectionTitle,
} from "../Components/PagesCompoents/Checkout/checkoutUiClasses";
import { GET_TAX_SUCCESS } from "../redux/constant/Events";
import Coupon from "../Components/PagesCompoents/Checkout/Coupon";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ApplyCoupon, RemoveCoupon } from "../redux/actions/CouponCode";
import PaymentInfo from "../Components/PagesCompoents/Checkout/PaymentInfo";
import OrderSummery from "../Components/PagesCompoents/Checkout/OrderSummery";
import PaymentMethodsComponent from "../Components/PagesCompoents/Checkout/PaymentMethods";
import PaymentMethods from "../Components/PagesCompoents/GroupDeatils/Sidebar/PaymentMethods";
import { getDiscountAmount } from "../utils/couponHelpers";
import { trackMeta } from "../utils/metaPixel";
import { trackEvent } from "../utils/googleAnalytics";
import axios from "axios";
import { getCreatorPromo } from "../creator/referral";

const Checkout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Location = useLocation();
  const params = useParams();
  const { filterevent, data, id, image: eventImage } = Location.state || {};

  // Check if this is a user-created event
  const isUserCreatedEvent = filterevent?.[0]?._isUserCreated ||
                            data?.id?.toString().length > 10;
  const user = useSelector((state) => state.user.user);
  const CouponLoading = useSelector((state) => state.couponcode.CouponLoading);
  const singleCouponCode = useSelector(
    (state) => state.couponcode.singleCouponCode
  );

  const [error, setError] = useState("");
  // Pre-fill the creator TEVO promo code when the buyer came through a creator link.
  const [coupon, setcoupon] = useState(() => getCreatorPromo() || "");
  const [payWith, setPayWith] = useState(0);
  const [PaymentInfoData, setPaymentInfoData] = useState({
    email: user?.email ? user?.email : "",
    fname: user?.firstName ? user?.firstName : "",
    lname: user?.lastName ? user?.lastName : "",
    address: "",
    country: "",
    city: "",
    zip: "",
    state:  "",
    phoneNumber: "",
    address_id: "",
  });
  const isPaymentInfoDataValue =
    PaymentInfoData.fname &&
    PaymentInfoData.lname &&
    PaymentInfoData.email &&
    PaymentInfoData.address &&
    PaymentInfoData.country &&
    PaymentInfoData.city &&
    PaymentInfoData.zip &&
    PaymentInfoData.phoneNumber &&
    PaymentInfoData.state &&
    PaymentInfoData.fname;
  const isloadingcreateOrder = useSelector((state) => state.events.isLoading);
  const isloadingUserOrder = useSelector((state) => state.order.isloading);
  const PaymentDetails = useSelector((state) => state.events.TaxData);

  // Organizer events: InstaPass per-ticket fee, added to the buyer's total unless
  // the organizer absorbs it. The server checks the charged amount against this.
  const [feeQuote, setFeeQuote] = useState(null);
  const feeEventId = filterevent?.[0]?._id || id;
  useEffect(() => {
    if (!isUserCreatedEvent || !feeEventId || data?.id == null) return undefined;
    let cancelled = false;
    setFeeQuote(null);
    axios
      .get(`${ApiURL}/payouts/fee-quote`, {
        params: { eventId: feeEventId, ticketTypeId: data.id, qty: data.qty || 1 },
      })
      .then(({ data: q }) => !cancelled && setFeeQuote(q))
      .catch(() => !cancelled && setFeeQuote({ buyerCharge: 0, failed: true }));
    return () => {
      cancelled = true;
    };
  }, [isUserCreatedEvent, feeEventId, data?.id, data?.qty]);
  const feeLoading = isUserCreatedEvent && !feeQuote;
  const checkoutData =
    isUserCreatedEvent && data ? { ...data, service_fee: feeQuote?.buyerCharge || 0 } : data;

  //   // handleRemoveCoupon
  const handleRemoveCoupon = () => {
    dispatch(RemoveCoupon());
    setcoupon("");
  };

  const checkoutOrderTotal =
    (checkoutData?.retail_price || 0) * (checkoutData?.qty || 0) +
    (PaymentDetails?.retail?.tax || 0) +
    (checkoutData?.service_fee || 0);

  //   /// handleApplyCoupon
  const handleApplyCoupon = async () => {
    if (!coupon) {
      toast.error("Coupon field is required");
      return;
    }
    await dispatch(ApplyCoupon(coupon, checkoutOrderTotal));
  };

  // handle place order
  const placeOrder = async (payemtResult) => {
    setError("");
    // save user address in local storage as
    if (user?.email) {
      const key = `userAddress_${user._id}`;
      const payload = {
        address:     PaymentInfoData.address,
        country:     PaymentInfoData.country,
        city:        PaymentInfoData.city,
        state:       PaymentInfoData.state,
        zip:         PaymentInfoData.zip,
        firstName:   PaymentInfoData.fname,
        lastName:    PaymentInfoData.lname,
        email:       PaymentInfoData.email,
        phoneNumber: PaymentInfoData.phoneNumber,
        userId:      user._id,
      };
      localStorage.setItem(key, JSON.stringify(payload));
    } else {
      const key = `guestAddress`;
      const payload = {
        address:     PaymentInfoData.address,
        country:     PaymentInfoData.country,
        city:        PaymentInfoData.city,
        state:       PaymentInfoData.state,
        zip:         PaymentInfoData.zip,
        firstName:   PaymentInfoData.fname,
        lastName:    PaymentInfoData.lname,
        email:       PaymentInfoData.email,
        phoneNumber: PaymentInfoData.phoneNumber,
        userId:      null,
      };
      localStorage.setItem(key, JSON.stringify(payload));
    }

    const offline = user?.email ? false : true;
    const paymentData = {
      payemtResult: payemtResult,
      wholesale_price: data?.wholesale_price,
      service_fee: PaymentDetails?.wholesale?.service_fee,
      tax: PaymentDetails?.wholesale?.tax,
      promo_code: singleCouponCode?.code || singleCouponCode?.promoCode || "",
      discount_amount: getDiscountAmount(checkoutOrderTotal, singleCouponCode),
      promo_source: singleCouponCode?.source || "",
      phoneNumber: user?.email
        ? user?.phoneNumber
        : PaymentInfoData?.phoneNumber,
      address: {
        address: PaymentInfoData?.address,
        country: PaymentInfoData?.country,
        city: PaymentInfoData?.city,
        zip: PaymentInfoData?.zip,
        state: PaymentInfoData?.state,
        address_id : PaymentInfoData.address_id
      },
    };

    if (isUserCreatedEvent) {
      // For user-created events, create orde locally (pass event info for invoice)
      // Pass the MongoDB _id from filterevent, not the ticket group id from data
      const eventId = filterevent?.[0]?._id || id;
      dispatch(CreateUserCreatedOrder(
        checkoutData,
        PaymentInfoData,
        PaymentDetails,
        paymentData,
        singleCouponCode?.value
          ? singleCouponCode?.percentage
            ? `${singleCouponCode?.value}%`
            : `${singleCouponCode?.value}$`
          : `0`,
        navigate,
        setError,
        filterevent,
        eventId
      ));
    } else {
      // For TEVO events, use normal order creation
      dispatch(CreateOrder(
        data && data?.id,
        data && data.qty,
        data && data?.retail_price,
        data && data?.format,
        id,
        user?.email ? user?.clientId : sessionStorage.getItem("client_id"),
        user?.email
          ? user?.emailAddressId
          : sessionStorage.getItem("emailAddressId"),
        dispatch,
        navigate,
        offline,
        PaymentInfoData.fname + " " + PaymentInfoData.lname,
        PaymentInfoData.email,
        PaymentInfoData.lname,
        PaymentDetails?.tax_signature,
        paymentData,
        setError,
        singleCouponCode?.value
          ? singleCouponCode?.percentage
            ? `${singleCouponCode?.value}%`
            : `${singleCouponCode?.value}$`
          : `0`
      ));
    }
  };

  // What the buyer is actually charged: order total minus any promo discount.
  const trackingValue = () => {
    const discount = getDiscountAmount(checkoutOrderTotal, singleCouponCode) || 0;
    return Math.max(0, Math.round((checkoutOrderTotal - discount) * 100) / 100);
  };
  const trackingParams = () => ({
    value: trackingValue(),
    currency: "USD",
    content_ids: [String(filterevent?.[0]?._id || id || data?.id || "")].filter(Boolean),
    content_name: filterevent?.[0]?.name || undefined,
    content_type: "product",
    num_items: Number(data?.qty) || 1,
    promo_code: singleCouponCode?.code || singleCouponCode?.promoCode || undefined,
  });

  // InitiateCheckout once, when the checkout first has a real order on it.
  const [checkoutTracked, setCheckoutTracked] = useState(false);
  useEffect(() => {
    if (checkoutTracked || !data?.qty || !checkoutOrderTotal) return;
    trackMeta("InitiateCheckout", trackingParams());
    trackEvent("begin_checkout", { value: trackingValue(), currency: "USD" });
    setCheckoutTracked(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, checkoutOrderTotal, checkoutTracked]);

  // when payment is complete
  const onPaymentCompleted = async (payemtResult) => {
    setPayWith(0);
    // Fire Purchase as soon as the payment itself succeeds — the order call
    // below navigates away, and a sale must not go unrecorded because of it.
    const txn = payemtResult?.payment_intent_id || payemtResult?.orderID || payemtResult?.id;
    trackMeta("Purchase", trackingParams(), txn);
    trackEvent("purchase", { transaction_id: txn, value: trackingValue(), currency: "USD",
      coupon: singleCouponCode?.code || singleCouponCode?.promoCode || undefined });
    await placeOrder(payemtResult);
  };

  useEffect(() => {
    if (isloadingcreateOrder || isloadingUserOrder) {
      Loading.standard("Loading Please Wait", {
        svgColor: "#CD292E",
      });
    } else {
      Loading.remove();
    }
  }, [isloadingcreateOrder, isloadingUserOrder]);

  useEffect(() => {
    const handleTax = async () => {
      setError("");

      // Check if this is a user-created event (no real TEVO ticket group)
      const isUserCreatedEvent = filterevent?.[0]?._isUserCreated ||
                                data?.id?.toString().length > 10; // Generated IDs are typically longer

      if (isUserCreatedEvent) {
        // For user-created events, set mock tax data since they don't have TEVO ticket groups
        const mockTaxData = {
          retail: {
            price: data?.price || data?.retail_price || 0,
            tax: 0, // No tax for user-created events
            total: data?.price || data?.retail_price || 0
          }
        };
        dispatch({ type: GET_TAX_SUCCESS, payload: mockTaxData });
      } else {
        // For TEVO events, call the tax API
        await dispatch(
          GetTaxData(
            {
              ticket_group_id: data?.id,
              quantity: data?.qty,
              price: data?.retail_price,
            },
            setError
          )
        );
      }

      await dispatch(RemoveCoupon());
    };

    handleTax();
  }, [data, dispatch]);

  const createTevoClient = async () => {
    if (!user?.email || !user?.clientId) {
      // create tevo client Api call
      const res = await fetch(`${ApiURL}/user/tevo/client`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: PaymentInfoData?.email,
          firstName: PaymentInfoData?.fname,
          lastName: PaymentInfoData?.lname,
        }),
      });
      const tevoClientData = await res.json();
      if (res.status === 400 || res.status === 500) {
        setError("Error Occured while creating Tevo Client");
        return toast.error("Error Occured while creating Tevo Client");
      }

      // save in session storage
      sessionStorage.setItem("client_id", tevoClientData?.client_id);
      sessionStorage.setItem("emailAddressId", tevoClientData?.emailAddressId);

      // return {
      //   client_id: tevoClientData?.client_id,
      //   emailAddressId: tevoClientData?.emailAddressId,
      // };

      return tevoClientData?.client_id;
    }
  };

  const eventTitle =
    (filterevent && filterevent[0]?.name) || params?.name || "Your event";

  return (
    <>
      <div className={checkoutPage}>
        <div className={checkoutContainer}>
          <h1 className={checkoutPageTitle}>Payment Information</h1>
          <p className={`${checkoutEventTitle} mb-6`}>{eventTitle}</p>

          {error && (
            <div role="alert" className={checkoutErrorAlert}>
              <span>Error: {error || "Something went wrong"}</span>
            </div>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:items-start">
            <div className="lg:col-span-2 space-y-6 min-w-0">
              <PaymentInfo
                PaymentInfoData={PaymentInfoData}
                setPaymentInfoData={setPaymentInfoData}
                format={data?.format}
              />

              <div className={checkoutCard}>
                <h2 className={checkoutSectionTitle}>Payment Method</h2>
                <p className="text-xs text-gray-500 mb-3">
                  {isUserCreatedEvent
                    ? "Refunds are up to the event organizer and only before the event starts. The InstaPass service fee isn't refundable."
                    : "Resale tickets are final sale — no refunds or exchanges."}
                </p>
                <Coupon
                  CouponLoading={CouponLoading}
                  coupon={coupon}
                  handleApplyCoupon={handleApplyCoupon}
                  handleRemoveCoupon={handleRemoveCoupon}
                  setcoupon={setcoupon}
                />
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  {!isUserCreatedEvent && (
                    <PaymentMethods
                      svg={CreditSvg}
                      title={"Credit Card"}
                      payWith={1}
                      isPaymentInfoDataValue={isPaymentInfoDataValue && !feeLoading}
                      setPayWith={setPayWith}
                      Active={true}
                    />
                  )}
                  {isUserCreatedEvent && (
                    <PaymentMethods
                      svg={StripeSvg}
                      title={"Stripe"}
                      payWith={5}
                      isPaymentInfoDataValue={isPaymentInfoDataValue && !feeLoading}
                      setPayWith={setPayWith}
                      Active={true}
                    />
                  )}
                  <PaymentMethods
                    svg={PaypalSvg}
                    title={"Paypal"}
                    payWith={2}
                    isPaymentInfoDataValue={isPaymentInfoDataValue && !feeLoading}
                    setPayWith={setPayWith}
                  />
                  <PaymentMethods
                    svg={AppleSvg}
                    title={"Apple Pay"}
                    payWith={3}
                    isPaymentInfoDataValue={isPaymentInfoDataValue && !feeLoading}
                    setPayWith={setPayWith}
                  />
                  <PaymentMethods
                    svg={GoogleSvg}
                    title={"Google Pay"}
                    payWith={4}
                    isPaymentInfoDataValue={isPaymentInfoDataValue && !feeLoading}
                    setPayWith={setPayWith}
                  />
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <OrderSummery
                PaymentDetails={PaymentDetails}
                data={checkoutData}
                singleCouponCode={singleCouponCode && singleCouponCode}
                event={filterevent}
                eventImage={eventImage}
              />
            </div>
          </div>
        </div>
        <MarketplaceNewUIFooter />
      </div>
      <PaymentMethodsComponent
        PaymentDetails={PaymentDetails}
        createTevoClient={createTevoClient}
        data={checkoutData}
        onPaymentCompleted={onPaymentCompleted}
        payWith={payWith}
        setPayWith={setPayWith}
        setError={setError}
        isUserCreatedEvent={isUserCreatedEvent}
      />
    </>
  );
};

export default Checkout;
